import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Typography, Skeleton } from "antd";
import EmptyState from "../../../shared/EmptyState";
import OnboardingCard from "../../../shared/OnboardingCard";

const { Text } = Typography;

const UserOnboardingByIdScreen = (props: any) => {
  const {
    onboarding,
    loading,
    loaded,
    actions: { getSingleOnboarding },
  } = props;

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getSingleOnboarding({ id });
  }, []);

  const renderStep = (step: any) => {
    switch (step?.type) {
      case "Course":
        return (
          <OnboardingCard
            title={step?.course?.title}
            coverImageKey={step?.course?.coverImageKey}
            entity={"View Course"}
            orderIndex={step?.orderIndex}
            isFinished={step.isFinished}
            locked={step?.locked}
            path={`/user/course/${step?.course?.id}`}
          />
        );

      case "Module":
        return (
          <OnboardingCard
            title={step?.module?.title}
            coverImageKey={step?.module?.coverImageKey}
            entity={"View Module"}
            orderIndex={step?.orderIndex}
            isFinished={step?.isFinished}
            locked={step?.locked}
            path={`/user/module/${step?.module?.id}`}
          />
        );

      case "Lesson":
        return (
          <OnboardingCard
            title={step?.lesson?.title}
            coverImageKey={step?.lesson?.coverImageKey}
            entity={"View Lesson"}
            orderIndex={step?.orderIndex}
            isFinished={step.isFinished}
            locked={step?.locked}
            path={`/user/lesson/${step?.lesson?.id}`}
          />
        );

      case "Quizzie":
        return (
          <OnboardingCard
            title={step?.quizzie?.title}
            coverImageKey={step?.quizzie?.coverImageKey}
            entity={"View Quizzie"}
            orderIndex={step?.orderIndex}
            isFinished={step.isFinished}
            locked={step?.locked}
            path={`/user/quizzie/${step?.quizzie?.id}`}
          />
        );

      case "Task":
        return (
          <OnboardingCard
            title={step?.task?.title}
            coverImageKey={step?.task?.coverImageKey}
            entity={"View Task"}
            orderIndex={step?.orderIndex}
            isFinished={step.isFinished}
            inProgress={!step.isApproved}
            locked={step?.locked}
            path={`/user/task/${step?.task?.id}`}
          />
        );

      default:
        break;
    }
  };

  if (loading) return <Skeleton active />;
  return (
    <div className="flex justify-center">
      <div className="flex flex-wrap gap-8 justify-center">
        {onboarding?.steps?.length > 0 &&
          onboarding.steps.map((step: any, index: number) => (
            <div key={index}>{renderStep(step)}</div>
          ))}
      </div>
    </div>
  );
};
export default UserOnboardingByIdScreen;
